<template functional>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2C6.486 2 2 6.48606 2 12.0001C2 17.5141 6.486 22 12 22C17.514 22 22 17.5141 22 12.0001C22 6.48606 17.514 2 12 2ZM12 20.1818C7.48848 20.1818 3.81818 16.5115 3.81818 12.0001C3.81818 7.48861 7.48848 3.81818 12 3.81818C16.5115 3.81818 20.1818 7.48861 20.1818 12.0001C20.1818 16.5115 16.5115 20.1818 12 20.1818Z"
      fill="#333333"
    />
    <path
      d="M11.9998 6.24242C11.3316 6.24242 10.7879 6.78642 10.7879 7.45508C10.7879 8.12315 11.3316 8.66666 11.9998 8.66666C12.6681 8.66666 13.2117 8.12315 13.2117 7.45508C13.2117 6.78642 12.6681 6.24242 11.9998 6.24242Z"
      fill="#333333"
    />
    <path
      d="M12.0001 10.4848C11.498 10.4848 11.091 10.8919 11.091 11.3939V16.8485C11.091 17.3505 11.498 17.7576 12.0001 17.7576C12.5021 17.7576 12.9092 17.3505 12.9092 16.8485V11.3939C12.9092 10.8919 12.5021 10.4848 12.0001 10.4848Z"
      fill="#333333"
    />
  </svg>
</template>

<script>
export default {};
</script>
